/**
 * The default config object
 */
export default {
	ajax_navigation: {
		enabled: false,
		module_id: '',
		disabled_pages: [],
		disabled_params: [],
		container_selector: null,
		content_selector: null,
	},
	apex_charts_locale: {
		name: 'en',
		options: {
			months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
			days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
			shortDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
			toolbar: {
				exportToSVG: 'Download SVG',
				exportToPNG: 'Download PNG',
				exportToCSV: 'Download CSV',
				menu: 'Menu',
				selection: 'Selection',
				selectionZoom: 'Selection Zoom',
				zoomIn: 'Zoom In',
				zoomOut: 'Zoom Out',
				pan: 'Panning',
				reset: 'Reset Zoom',
			},
		},
	},
	cookie: {
		path: '/',
		domain: location.hostname,
		secure: location.protocol === 'https:',
		/** @type {'none'|'None'|'lax'|'Lax'|'strict'|'Strict'} */
		samesite: 'lax',
	},
	env: {
		request_id: null,
		geo_cookie_name: null,
		language: {
			iso_code: 'en',
			lang_locale: 'en_US',
			canonical_locale: 'en-US',
		},
		timezone: undefined,
		revision: '0',
		js_revision: '0',
		sw_revision: '0',
	},
	facebook: {
		enabled: false,
	},
	page: {
		request_handle: null,
		language_urls: null,
		scroll_restoration: 'auto',
	},
	remote_action: {
		/** @type {boolean|'post'} */
		force_global_submit: false,
	},
	routes: {},
	rules: {
		overlays: {
			navigation: {
				click_selector: 'a[href]:not([href=""], [href^="#"], [href^="javascript:"], [rel~="external"], [target])',
				submit_selector: 'form:not([rel~="external"], [data-ajax-submit], [target])',
			},
		},
	},
	ui: {
		navbar_top_selector: '#mp-navbar-top',
		menubar_selector: '#mp-menubar',
		selector: 'body',
		lang_selector: '#mp-json-translations',
		report_lang_errors: false,
		icons_map_selector: '#mp-json-icons-map',
		icons_selector: 'i.mdi',

		// form_row_selector: '.form-row',
		form_column_selector: '.form-column',
		form_section_selector: '.form-section',
		form_row_selector: '.widget-row',
		form_group_selector: '.form-group',
		form_option_group_selector: '.form-option-group',

		// ---> Deprecated
		form_js_validation_selector: '[data-js-validation]',
		// form_validator_container_selector: '.form-option-group, .form-group, .form-row',
		form_validator_container_selector: '.widget-row',
		form_row_invalid_selector: '.form-row-invalid',
		form_row_invalid_class: 'form-row-invalid',
		form_row_invalid_feedback_class: 'form-row-invalid-feedback',
		// <--- Deprecated

		scroll_top_arrow_selector: '#scroll-to-top-arrow',
		form_validation: {
			/** @type {'bootstrap' | 'parsley'} */
			mode: 'parsley', // bootstrap, parsley
			js_validation_selector: '[data-js-validation]',
			row_selector: '.widget-row',
			context_selector: '.form-row',
			group_selector: '.form-group',

			// Bootstrap mode
			// invalid_class: 'is-invalid',

			// Parsley mode
			invalid_class: 'row-is-invalid',

			// Available for both modes
			invalid_feedback_class: 'invalid-feedback',
		},
		alert: {
			selector: '.alert',
			dismissible_selector: '.alert-dismissible',
			container_dismissible_selector: '.container-dismissible',
			markup: '<div class="alert alert-error alert-dismissible" role="alert"><div class="alert__message">%message%</div></div>',
		},
		dialog: {
			wrapper: {
				'class': 'modal-ask',
			},
			body: {
				'class': 'modal-body-centered-y',
			},
			footer: {
				type: 'div',
				attributes: {
					'class': 'dialog-buttons',
				},
			},
			alert: {
				default_title_icon: void 0,
				default_buttons: {
					ok: {
						type: 'button',
						attributes: {
							type: 'button',
							'class': 'btn btn-primary',
							'data-bs-dismiss': 'modal',
						},
						text: void 0,
					},
				},
			},
			confirm: {
				default_title: void 0,
				default_content: void 0,
				default_format: 'primary',
				default_buttons: {
					ok: {
						type: 'button',
						attributes: {
							type: 'button',
							'class': 'btn btn-danger',
							'data-bs-dismiss': 'modal',
						},
						text: void 0,
					},
					cancel: {
						type: 'button',
						attributes: {
							type: 'button',
							'class': 'btn btn-white bg-transparent',
							'data-bs-dismiss': 'modal',
						},
						text: void 0,
					},
				},
			},
		},
		focustrap: {
			// TinyMCE and Moxman are excluded by default
			excluded_elements: '.tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root' +
				// Select2 is excluded by default
				', .select2-container' +
				// The litepicker plugin is excluded by default
				', .litepicker' +
				// By specific class
				', .ignore-focustrap',
		},
		toast: {
			container_class: 'toast-container',
			container_position_class: 'toast-container-%axis%-%position%',
			toast_class: 'toast',
			toast_format_class: 'toast-%format%',
			wrapper_no_title_class: 'toast-wrapper',
			wrapper_title_class: 'toast-header',
			title_class: 'toast-title',
			body_class: 'toast-body',
			icon_container_class: 'toast-icon',
			/** @type {import('../modules/components/toast').MpToastOptions} */
			options: {
				positionX: 'right',
				positionY: 'top',
				delay: 7000,
				autohideError: false,
			},
		},
	},
	visitor: {
		device: '',
		country_code: '',
		country_id: 0,
	},
	websocket: {
		enabled: false,
		/** @type {WSClientConnectionOptions} */
		connection: null,
		/** @type {WSClientUserOptions} */
		user: null,
	}
};
